exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.label--3ZwhxLRa{margin:.5rem 0;color:#555;font-weight:700;box-shadow:none;font-size:1rem}@media only screen and (min-device-width:768px) and (max-device-width:1024px) and (-webkit-min-device-pixel-ratio:1) and (-webkit-max-device-pixel-ratio:2){.label--3ZwhxLRa{font-size:1.1rem}}", ""]);

// exports
exports.locals = {
	"label": "label--3ZwhxLRa"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/sign_up/shared/label/styles.scss
// module id = 1044
// module chunks = 0